import EDHttp from '../utils/EDHttp';

export default
{
    getMail:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.get(`/inbox/global/messages/${id}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    dismissMail:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.put(`/inbox/global/messages/${id}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    archiveMail:function(emails)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.post(`/inbox/global/archive`,{emails}).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    load:function(id,action,page=0,sort,search)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.get(`/inbox/${id}/${action}/${page}/${sort}?search=${search}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    unreadMessagesCount:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.get(`/inbox/unread/${id}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    getMessage:function(id,message)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.get(`/inbox/message/${id}/${message}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    async sendEmail(id,subject,message,attachments,from)
    {
        try {
            const { data: result } = await EDHttp.post(`/inbox/${id}/send`, { subject, message, attachments, from })
            return result.data;
        } catch (error) {
            throw error.response.data.message
        }
    },
    uploadAttachment:function(formData) {
        return new Promise((resolve,reject)=>
        {
            EDHttp.uploadFormData("/inbox/upload",formData).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    }
}